import styled from "styled-components";
import { font, theme } from "styles";

export const DetailText = styled.div`
  font-weight: ${font.weight.regular};
  font-size: 16px;
  color: ${theme.colors.NightSky};
  line-height: 24px;
`;
